import React from 'react'

const FavoriteContext = React.createContext({})

export const FavoriteProvider = FavoriteContext.Provider
export const FavoriteConsumer = FavoriteContext.Consumer
export default FavoriteContext
